import React from 'react';
import './middle.css';

function MiddleContainer() {
    return (
        <div className="middle-container">
            <div className="middle-section">
                <h1>Hire me for your awesome project</h1>
                <a href="tel:8689868867" className="button">Contact Me</a>

                {/* ********** Animation  ************ */}
                
                <img src={process.env.PUBLIC_URL + '/image/icons/triangle.png'} className="triangle" alt="Ashish Gupta"/>
                <div className="circle-round"></div>
                <div className="circle-round round2"></div>
                <img src={process.env.PUBLIC_URL + '/image/icons/dot-line.png'} className="dot-line" alt="Ashish Gupta"/>


            </div>{/* Middle section end  */}


            {/* **********  Animation  *********** */}

            <img src={process.env.PUBLIC_URL + '/image/icons/mini-dot.png'} className="mini-dot mini-dot2" alt="Ashish Gupta"/>
            <img src={process.env.PUBLIC_URL + '/image/icons/mini-dot.png'} className="mini-dot" alt="Ashish Gupta"/>
            <img src={process.env.PUBLIC_URL + '/image/icons/light-star.png'} className="light-star" alt="Ashish Gupta"/> 
            <img src={process.env.PUBLIC_URL + '/image/icons/light-wave.png'} className="light-wave" alt="Ashish Gupta"/>
            <img src={process.env.PUBLIC_URL + '/image/icons/light-wave.png'} className="light-wave wave2" alt="Ashish Gupta"/>

            <div className="circle-fill"></div>

        </div>
    )
}

export default MiddleContainer
